/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateMyNativeAidRequest
 */
export interface CreateMyNativeAidRequest {
    /**
     * Autonomic Identifier
     * @type {string}
     * @memberof CreateMyNativeAidRequest
     */
    aid: string;
    /**
     * Human-readable Identifier for AID
     * @type {string}
     * @memberof CreateMyNativeAidRequest
     */
    alias?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateMyNativeAidRequest
     */
    oobi: Array<string>;
    /**
     * Organization Id for whose benefit the workflow is performed or the user works
     * @type {string}
     * @memberof CreateMyNativeAidRequest
     */
    orgId?: string;
    /**
     * Type of the AID
     * @type {string}
     * @memberof CreateMyNativeAidRequest
     */
    type: string;
    /**
     * Does AID relate to multisig or singlesig?
     * @type {boolean}
     * @memberof CreateMyNativeAidRequest
     */
    isMultisig?: boolean;
    /**
     * Number of users required for signing. Used for multisigs only
     * @type {string}
     * @memberof CreateMyNativeAidRequest
     */
    signingThreshold?: string;
}

/**
 * Check if a given object implements the CreateMyNativeAidRequest interface.
 */
export function instanceOfCreateMyNativeAidRequest(value: object): boolean {
    if (!('aid' in value)) return false;
    if (!('oobi' in value)) return false;
    if (!('type' in value)) return false;
    return true;
}

export function CreateMyNativeAidRequestFromJSON(json: any): CreateMyNativeAidRequest {
    return CreateMyNativeAidRequestFromJSONTyped(json, false);
}

export function CreateMyNativeAidRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMyNativeAidRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'aid': json['aid'],
        'alias': json['alias'] == null ? undefined : json['alias'],
        'oobi': json['oobi'],
        'orgId': json['orgId'] == null ? undefined : json['orgId'],
        'type': json['type'],
        'isMultisig': json['isMultisig'] == null ? undefined : json['isMultisig'],
        'signingThreshold': json['signingThreshold'] == null ? undefined : json['signingThreshold'],
    };
}

export function CreateMyNativeAidRequestToJSON(value?: CreateMyNativeAidRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'aid': value['aid'],
        'alias': value['alias'],
        'oobi': value['oobi'],
        'orgId': value['orgId'],
        'type': value['type'],
        'isMultisig': value['isMultisig'],
        'signingThreshold': value['signingThreshold'],
    };
}

